// Components
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import Heading from '@/components/atoms/Heading/Heading';
import Button from '@/components/atoms/Button/Button';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Other
import { type BlocEquipeType } from '@/services/blocksSchema';
import VectorRed from '@/assets/blocks/vector-red.svg?react';
import VectorDark from '@/assets/blocks/vector-dark.svg?react';

// Style
import styles from './BlocEquipe.module.css';

interface BlocEquipeProps {
  preTitle: BlocEquipeType['preTitle'];
  title?: BlocEquipeType['title'];
  experts?: BlocEquipeType['experts'];
  button?: BlocEquipeType['button'];
}

function BlocEquipe({
  preTitle,
  title = null,
  experts = null,
  button = null,
}: BlocEquipeProps) {
  
  return (
    <div className={styles.bg}>
      <VectorRed />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles['content-header']}>
            <PreTitle
              preTitle={preTitle}
            />
            {
              title ? (
                <Heading
                  title={title}
                  size='h2'
                  Tag='h2'
                  color='dark'
                  align='center'
                />
              ) : null
            }
          </div>
          {
            experts ? (
              <div className={styles.experts}>
                {
                  experts.map((expert) => (
                    <div key={expert.documentId} className={styles.expert}>
                      <CmsImage
                        media={expert.image}
                        sizes="(max-width: 1024px) 100vw, 305px"
                        className={styles['expert-image']}
                      />
                      <div className={styles['expert-content']}>
                        <Heading
                          title={expert.name}
                          size='h4'
                          Tag='h4'
                          color='red'
                        />
                        <PreTitle
                          preTitle={expert.role}
                          size='p3'
                        />
                      </div>
                    </div>
                  ))
                }
              </div>
            ) : null
          }
          {
            button ? (
              <Button
                title={button.title}
                url={button.url}
                bgColor='red'
              />
            ) : null
          }
        </div>
      </div>
      <div className={styles['vector-dark']}>
        <VectorDark />  
      </div>
    </div>
  );
}

export default BlocEquipe;
